export const tr = {
    'not-found': 'Sonuç bulunamadı',
    'not-selected': 'Hiçbir değer seçilmedi',
    'search-placeholder': 'Deney arama',
    title: 'Aktif deneyler'
};
